export const contentTableConfig = {
  title: '发布信息列表',
  propList: [
    { prop: 'name', label: '学生姓名', minWidth: '100' },
    { prop: 'phone', label: '手机号', minWidth: '100' },
    { prop: 'levelName', label: '级别', minWidth: '80' },
    { prop: 'gradeName', label: '年级', minWidth: '80' },
    { prop: 'duration', label: '授课时长/h', minWidth: '100' },
    { prop: 'schoolName', label: '学生学校', minWidth: '100' },
    { prop: 'stuAddress', label: '学生地址', minWidth: '100' },
    { prop: 'teachingWayKey', label: '授课方式', minWidth: '80', slotName: 'teachingWayKey' },
    { prop: 'subjectName', label: '授课科目', minWidth: '80' },
    { prop: 'teacherEducationalName', label: '教师学历', minWidth: '100' },
    { prop: 'isSuccess', label: '状态', minWidth: '80', slotName: 'isSuccess' },
    { prop: 'hander', label: '操作', minWidth: '120', slotName: 'operate' }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  showFooter: true
}
